import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Admin from "../../admin/containers/admin";
import SliceMenuApp from "../../admin/components/slice-menu";
import SelectedCompanies from "../../companies/selected-company";
import "../../../../static/css/dashboard.css";
import Reportes from "../infoViz/cubejs/cubejsInteractionReport";

import { Col, Row, Container, FormGroup, Label, Input } from "reactstrap";
import ToolbarApp from "../../admin/components/toolbar";
import BotMenuOptions from "../../menus/analytics-menu-options";
import Date from "../../../components/datepicker-dashboard";

import {
  setSelectedCompany,
  setSelectedReport,
  setSelectedBot,
  getAllMetrics,
  getAllCharts,
  getBlockChainReport,
  getBuilderQuery,
  getPagination,
  iconLoad,
  iconHideLoad,
} from "../../../redux/actions/analyticsActions";

import i18next from "../../../../i18n";

function BotBlockChainReportLayout(props) {
  const { listAllCompanies = [] } = props.homeReducer;
  const {
    listAllBotsbyCompany = [],
    listAllCustomReports,
    selectedReport,
    selectedBot,
  } = props.analyticsReducer;

  return (
    <div className="BotLayout">
      <Admin>
        <SliceMenuApp>
          <BotMenuOptions admin={props.isAdmin} handleFind={props.handleFind} />
        </SliceMenuApp>
        <Container fluid>
          <ToolbarApp>
            <Row>
              <Col sm="6" md="6" className="text pdtoolbar">
                <h2 className="text-left ml-4 font-weight-bold">
                  {i18next.t('report_blockchain')}<span className="btn-help"></span>
                </h2>
              </Col>
              {props.isAdmin ? (
                <SelectedCompanies
                  onchangeCompanies={onchangeCompanies}
                ></SelectedCompanies>
              ) : null}
              <Col sm="3" md="3" className="filter-stuff">
                <FormGroup>
                  <Label
                    sm={3}
                    for="botName"
                    className="text-left font-weight-bold"
                    style={{ color: "#5a5a5a" }}
                  >
                    Bot:
                  </Label>
                  <Input
                    type="select"
                    name="select"
                    bsSize="sm"
                    id="gotSelect"
                    defaultValue={selectedBot ? selectedBot.id : ""}
                    onChange={(e) => onchangeBot(e)}
                  >
                    {listAllBotsbyCompany &&
                      listAllBotsbyCompany.length > 0 &&
                      listAllBotsbyCompany.map((bot, i) => {
                        return (
                          <option key={bot.id} value={bot.id} data={bot}>
                            {bot.name}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          </ToolbarApp>
        </Container>
        <Container fluid className="box-fluid">
        {
           listAllCustomReports &&(listAllCustomReports.length > 0 )?(
          <Col sm="12" md="10" className="stadistics-container offset-md-1">
            <div id="wdr-component"></div>
            <Col sm="3" md="3" className="filter-stuff">
                <FormGroup>
                  <Label
                    sm={3}
                    for="botName"
                    className="text-left font-weight-bold"
                    style={{ color: "#5a5a5a" }}
                  >
                    {i18next.t('report')+': '}
                  </Label>
                  <Input
                    type="select"
                    name="select"
                    bsSize="sm"
                    id="gotSelect"
                    defaultValue={selectedReport ? selectedReport.id : ""}
                    onChange={(e) => onchangeReport(e)}
                  >
                    {listAllCustomReports &&
                      listAllCustomReports.length > 0 &&
                      listAllCustomReports.map((bot, i) => {
                        return (
                          <option key={bot.id} value={bot.id} data={bot}>
                            {bot.title}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
              </Col>
            {/* <Col
              sm="6"
              md="6"
              className="offset-md-2 offset-lg-6 filter-stuff col-sm-12 col-md-10 col-lg-6"
            >
              <Date></Date>
            </Col>*/}
            {selectedReport &&(selectedReport.id) ? (
              <Reportes
                onFilter={props.getBlockChainReport}
                isSuperUser={props.isSuperUser}
              />
            ) : (
              <div></div>
            )}
          </Col>
           ):
           <Col sm="12" md="10" className="stadistics-container offset-md-1">
              <Col xs={12} lg={8} className="offset-lg-2 intro-funnels">
                    <Row>
                        <Col xs={12}><img src="/static/img/blank_state.png" className="img-fluid"/></Col>
                        <Col xs={12}>
                            <h2>{i18next.t('blockchain_report_msg')}</h2>
                            <h3>{i18next.t('hear_found_personalized_report')}</h3>
                            <p>{i18next.t('blockchain_report_msg2')}.</p>
                        </Col>
                    </Row>
                </Col>
            </Col>
            }
        </Container>
      </Admin>
    </div>
  );

  //----------------------------------------------------------------------------
  //  CUANDO SE SELECCIONA UN BOT ACTUALIZA EL SELECTEDBOT
  //------------------------------------------------------------------------------
  async function onchangeBot(e) {
    const id_bot = e.target.value;

    await props.iconLoad();
    await props.setSelectedBot(id_bot);
  }
  //----------------------------------------------------------------------------
  //  CUANDO SE SELECCIONA UNA COMPAÑÍA ACTUALIZA EL SELECTEDCOMPANY
  //------------------------------------------------------------------------------
  async function onchangeCompanies(e) {
    const id_company = e.value;

    await props.iconLoad();
    await props.setSelectedCompany(id_company);
  }

  //----------------------------------------------------------------------------
  //  CUANDO SE SELECCIONA UN REPORTE
  //------------------------------------------------------------------------------
  async function onchangeReport(e) {
    const id_creport = e.target.value;

    await props.iconLoad();
    await props.setSelectedReport(id_creport);
  }

  
}

const mapStateToProps = ({ analyticsReducer, homeReducer }) => {
  return { analyticsReducer, homeReducer };
};

const mapDispatchToProps = {
  setSelectedCompany,
  setSelectedReport,
  setSelectedBot,
  getAllMetrics,
  getAllCharts,
  getBuilderQuery,
  getPagination,
  iconLoad,
  iconHideLoad,
  getBlockChainReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BotBlockChainReportLayout));
